import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AutoparkFormView } from './autopark-form-view';
import {
	getAutoparkCompaniesListSelector,
	getIsAutoparkCompaniesListLoadingSelector,
	getFormInitialValuesSelector,
} from '../../selectors';
import { AUTOPARK_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const AutoparkFormWrapper = ({ autoparkCompaniesList, isAutoparkCompaniesListLoading }) => {
	return (
		<AutoparkFormView
			autoparkCompaniesList={autoparkCompaniesList}
			isAutoparkCompaniesListLoading={isAutoparkCompaniesListLoading}
		/>
	);
};

const withForm = reduxForm({
	form: AUTOPARK_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(AutoparkFormWrapper);

const mapStateToProps = createStructuredSelector({
	initialValues: getFormInitialValuesSelector(),
	autoparkCompaniesList: getAutoparkCompaniesListSelector(),
	isAutoparkCompaniesListLoading: getIsAutoparkCompaniesListLoadingSelector(),
});

AutoparkFormWrapper.propTypes = {
	autoparkCompaniesList: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAutoparkCompaniesListLoading: PropTypes.bool.isRequired,
};

const AutoparkForm = connect(mapStateToProps)(withForm);

export { AutoparkForm };
